export * as TrackedWalletSwapAlert from './tracked-wallet-swap-alert'
export const WALLET_TRACKER_EMOJIS = [
  '🔥',
  '🚀',
  '❤️',
  '🤔',
  '🤷‍♂️',
  '🤷‍♀️',
  '😂',
  '😎',
  '👍',
  '🎉',
  '😢',
  '😡',
  '👏',
  '💡',
  '😴',
  '😇',
  '😜',
  '😱',
  '😷',
  '😺',
]
